module.exports = __webpack_public_path__ + "img/rock-huge-06.6b6e99d6.png";